// ABOUTME: Typed fetch helpers for the api-worker /platform-models proxy routes
// ABOUTME: Centralizes shape declarations so pages + hooks reference one type

import { apiClient } from './client';

export interface PlatformModel {
  id: string;
  consumerId: string;
  marketType: string;
  horizon: string;
  modelFamily: string;
  metricsJson: string;
  featureSpecHash: string;
  objectStoreKey: string;
  championRank: number | null;
  createdAt: string;
}

export interface PlatformModelOnnxUrl {
  modelId: string;
  url: string;
  expiresInSeconds: number;
}

export async function fetchPlatformModels(opts: {
  marketType?: string;
  horizon?: string;
}): Promise<PlatformModel[]> {
  const qs = new URLSearchParams();
  if (opts.marketType) qs.set('marketType', opts.marketType);
  if (opts.horizon) qs.set('horizon', opts.horizon);
  const suffix = qs.toString() ? `?${qs.toString()}` : '';
  const res = await apiClient.get<{ data: PlatformModel[] }>(`/platform-models${suffix}`);
  return res.data.data;
}

export async function fetchPlatformModelOnnxUrl(modelId: string): Promise<PlatformModelOnnxUrl> {
  const res = await apiClient.get<{ data: PlatformModelOnnxUrl }>(
    `/platform-models/${encodeURIComponent(modelId)}/onnx-url`
  );
  return res.data.data;
}
